import React, { PropTypes } from 'react';
// import './styles.scss';

import { Link } from 'react-router'

class FourOhFour extends React.Component {
  constructor(props) {
    super(props);
    //this.state = {};
  }

  render () {
    // let dogImage = require("./images/404-img.png"),
        // logoColor = require("./images/logo-color.svg");

    return (
      <div className="FourOhFour text-center">
        <img src="/images/logo-color.svg" />
        <div className="SetterBase-spacer-tall"></div>
        <span>He seems confused too!</span>
        <img className="img-pic" src="/images/404-img.png" />
        <span>The page you are looking for can't be found, sorry!</span>
        <div className="SetterBase-spacer-tall"></div>
        <div className="divider"></div>
        <div className="SetterBase-spacer-tall"></div>
        <div className="group-btn text-center">
          {/*<button className="btn btn-default btn-back">BACK</button>*/}
          {/*<button className="btn btn-success">HOME</button>*/}
          <Link to="/" className="btn btn-success">HOME</Link>
        </div>
      </div>
    );
  }
}

FourOhFour.propTypes = {

};

FourOhFour.defaultProps = {

};

export default FourOhFour;



/** WEBPACK FOOTER **
 ** ./404.js
 **/